/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial del usuario
 */
export const INITIAL_USER_STATE = {
  uuid: null,
  names: '',
  email: '',
  password: '',
  telephone: '',
  is_active: true,
  is_administrator: false,
  uuid_rol: '',
  timezone: '',
  uuid_subscriber: null,
};

/**
 * Configuración de validaciones
 */
export const VALIDATION_RULES = {
  EMAIL: {
    PATTERN: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
  PHONE: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 15,
    PATTERN: /^[\d\s()+-]+$/,
  },
  PASSWORD: {
    MIN_LENGTH: 8,
  },
  NAMES: {
    MIN_LENGTH: 2,
    MAX_LENGTH: 100,
  },
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Usuario creado exitosamente',
    UPDATE: 'Usuario actualizado exitosamente',
    DELETE: 'Usuario eliminado exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear el usuario',
    UPDATE: 'Error al actualizar el usuario',
    DELETE: 'Error al eliminar el usuario',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_EMAIL: 'Email inválido',
    INVALID_PHONE: 'Teléfono inválido',
    PASSWORD_TOO_SHORT: 'La contraseña debe tener al menos 8 caracteres',
    NAME_TOO_SHORT: 'El nombre debe tener al menos 2 caracteres',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  user: { width: '15%' },
  names: { width: '20%' },
  telephone: { width: '15%' },
  email: { width: '25%' },
  role: { width: '10%' },
  actions: { width: '15%' },
};
